import React from "react"
import classnames from "classnames"
import Img from "gatsby-image"
import { FormattedMessage } from "react-intl"
import { navigate } from "gatsby"
import { useIntl } from "react-intl"
import { useIsLangEN } from "../hooks"
import { CoverImage } from "../components"

const ImageFrame = ({
  fluidImg,
  title,
  subtitle,
  imgAlt,
  imgTitle,
  date,
  baseSlug,
  baseSlug4Title,
  style,
  className,
  isCoverImg,
  noTitleSpace,
}) => {
  const intl = useIntl()
  const isLangEN = useIsLangEN()
  return (
    <article
      onClick={() => {
        // navigate(`/${intl.locale}/${baseSlug}`)
        window.location.href = `${baseSlug}/`
      }}
      className={classnames("image-frame", className)}
      style={style}
    >
      {!noTitleSpace && (
        <div
          className={classnames({
            "image-frame__title": true,
            "image-frame__title--notitle": !title,
          })}
          onClick={
            baseSlug4Title
              ? e => {
                  e.stopPropagation()
                  // navigate(`/${intl.locale}/${baseSlug4Title}`)
                  window.location.href = `${baseSlug4Title}/`
                }
              : undefined
          }
        >
          {title}
        </div>
      )}
      <div className="image-frame__image">
        {isCoverImg ? (
          <CoverImage imgAlt={imgAlt} imgTitle={imgTitle}></CoverImage>
        ) : (
          <Img fluid={fluidImg} alt={imgAlt} title={imgTitle}></Img>
        )}
      </div>
      {subtitle ? (
        <h2
          className={classnames({
            "image-frame__img-title": true,
            "image-frame__img-title--en": isLangEN,
          })}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        ></h2>
      ) : (
        <div
          className={classnames({
            "image-frame__img-title": true,
            "image-frame__img-title--en": isLangEN,
          })}
        ></div>
      )}

      <div className="image-frame__date">{date}</div>
    </article>
  )
}

export default ImageFrame
